import type { FC } from "react";
import { RichText } from "@components/cms/rich-text-renderer/RichText";
import { Box } from "@ecco/ui/box";
import { Flex } from "@ecco/ui/flex";
import type { TextModel } from "@lib/contentful/mappers/modules/text/types";
import type { Options as RichTextOptions } from "@components/cms/rich-text-renderer/richTextOptions";

type TextProps = TextModel & {
    richTextOptions?: RichTextOptions;
};

const widthMap = {
    small: ["full", "full", "full", "full", "60%"],
    medium: ["full", "full", "full", "full", "70%"],
    "full width": "full",
};

export const Text: FC<TextProps> = ({
    text,
    textAlign = "center",
    textWidth = "full width",
    richTextOptions,
}) => (
    <Flex w="full" flexDirection="column" textAlign={textAlign} gap={4} alignItems="center">
        <Box w={widthMap[textWidth]}>
            <RichText data={text} options={richTextOptions} />
        </Box>
    </Flex>
);
